export default "__VITE_ASSET__Dji$c9Gw__"